import axios from 'src/utils/request'
export const user = {
    login: (...args: any[]) => 
        axios.post('/login', ...args),
}